<div *ngIf="screenSize.isMobile" class="offcanvas-body p-0 sidemenu-container">
  <ng-container *ngTemplateOutlet="sideNavContent"></ng-container>
</div>

<div *ngIf="!screenSize.isMobile" class="sidemenu-container">
  <ng-container *ngTemplateOutlet="sideNavContent"></ng-container>
</div>

<ng-template #sideNavContent>
  <div class="sidemenu-wrapper">
    <div class="sidemenu-content">
      <mat-toolbar class="mb-2" style="background-color: transparent">
        <a [href]="['./']" routerLinkActive="router-link-active" class="navbar-logo">
          <img src="assets/LogoDentalTour.png" class="logo-image" />
        </a>
      </mat-toolbar>
      <mat-nav-list>
        <ng-container *ngFor="let item of menuItems">
          <a class="list-item" *ngIf="!item.subItems" mat-list-item [class.active]="activeItem === item"
            [class.disabled]="!item.enabled" disableRipple (click)="item.enabled && onItemClick(item)">
            <div class="menu-list-item">
              <i class="ti me-2" [class]="'ti ti-' + item.icon"></i>
              <span style="width: 100%">{{ item.label }}</span>
              <app-sidebar-badge *ngIf="item.badgeCount !== undefined" [count]="item.badgeCount"></app-sidebar-badge>
            </div>
          </a>

          <a class="list-item" *ngIf="item.subItems" mat-list-item (click)="item.enabled && onItemClick(item)"
            [class.disabled]="!item.enabled" disableRipple [class.active]="activeItem === item">
            <div class="menu-list-item">
              <i class="ti me-2" [class]="'ti ti-' + item.icon"></i>
              <span style="width: 100%">{{ item.label }}</span>
              <app-sidebar-badge *ngIf="item.badgeCount !== undefined" [count]="item.badgeCount"></app-sidebar-badge>
            </div>
          </a>

          <ng-container *ngIf="item.open">
            <a (click)="sub.enabled && onItemClick(sub)" class="list-item sub" *ngFor="let sub of item.subItems"
              mat-list-item [class.disabled]="!sub.enabled" [class.active]="activeItem === sub" disableRipple>
              <div class="menu-list-item child">
                <i class="ti me-2" [class]="'ti ti-' + sub.icon"></i>
                <span style="width: 100% !important">{{ sub.label }}</span>
                <i class="ti ti-chevron-right"></i>
              </div>
            </a>
          </ng-container>
        </ng-container>
      </mat-nav-list>
    </div>

    <div class="sidemenu-footer" *ngIf="showPartnerFooter">
      <div *ngIf="profileService.isPartner" class="partner-section">
        <div class="partner-content">
          <div class="partner-image-wrapper">
            <img [src]="partnerData.coverUrlThumbnail || 'assets/dentalclinic.webp'" [alt]="partnerData.name"
              class="partner-image" />
          </div>
          <div class="partner-info">
            <div class="partner-name">{{ partnerData.name }}</div>
            <div class="partner-location" *ngIf="partnerData.region || partnerData.country">
              <i class="ti ti-map-pin"></i>
              <span>{{ partnerData.district }}, {{ partnerData.region }}<ng-container *ngIf="partnerData.region && partnerData.country"> -
                </ng-container>{{ partnerData.country }}</span>
            </div>
            <div class="partner-languages"
              *ngIf="partnerData.languagesSpoken && partnerData.languagesSpoken.length > 0">
              <i class="bi bi-globe small text-muted" style="font-size: 12px;"></i>
              <div class="flags-container">
                <img *ngFor="let lang of languageFlags" [src]="lang.src" [alt]="lang.name" [title]="lang.name"
                  class="flag-icon" />
              </div>
            </div>
          </div>
        </div>
        <a [href]="'en/partner/' + currentPartnerId" target="_blank" class="partner-profile-btn">
          <span>View my profile</span>
          <i class="ti ti-external-link"></i>
        </a>
      </div>
    </div>
  </div>
</ng-template>
